import { ExternalLink, ShoppingBag } from "lucide-react";
import KineticMarquee from "@/components/KineticMarquee";
import { SOCIAL_LINKS } from "@/data/content";

export default function Merch() {
  return (
    <div data-testid="merch-page" className="px-6 lg:px-12 py-16 lg:py-24 text-[var(--tsws-green)]">
      <div className="grid lg:grid-cols-12 gap-10 items-end mb-12">
        <div className="lg:col-span-8">
          <span className="font-label text-xs text-[var(--tsws-cigar)]">⏤ Wear The Sesh</span>
          <h1 className="font-display text-7xl md:text-8xl lg:text-[12rem] mt-3 leading-[0.82]">
            merch<span className="text-[var(--tsws-cigar)]">.</span>
          </h1>
        </div>
        <div className="lg:col-span-4">
          <p className="font-tag text-xl">Threads, hats, stubby holders.</p>
          <p className="mt-3 leading-relaxed opacity-85">
            Every dollar keeps the mics on and the fridge stocked.
          </p>
        </div>
      </div>

      <KineticMarquee phrases={["ship worldwide", "limited drops", "support the show"]} />

      <div className="mt-20 lg:mt-28 flex flex-col items-center text-center">
        <div className="font-display text-6xl md:text-7xl lg:text-8xl leading-[0.9] max-w-3xl">
          shop the<br />
          full range<span className="text-[var(--tsws-cigar)]">.</span>
        </div>
        <p className="font-tag text-2xl mt-6 max-w-xl">
          New drops, classics, sizes and shipping — all live on the official Big Cartel store.
        </p>

        <a
          href={SOCIAL_LINKS.merch}
          target="_blank"
          rel="noreferrer"
          data-testid="merch-shop-cta"
          className="mt-12 font-display text-xl md:text-2xl px-10 py-6 border-2 border-[var(--tsws-green)] bg-[var(--tsws-green)] text-[var(--tsws-orange)] hover-brutal hover:bg-[var(--tsws-cigar)] hover:border-[var(--tsws-cigar)] inline-flex items-center gap-3"
        >
          <ShoppingBag size={22} /> visit the store <ExternalLink size={20} />
        </a>

        <p className="mt-6 font-tag text-sm opacity-70 break-all">
          {SOCIAL_LINKS.merch.replace(/^https?:\/\//, "")}
        </p>
      </div>
    </div>
  );
}
